import React from "react";
import {useSelector} from "react-redux";
import {T} from "@tolgee/react";
import {Button} from "@material-ui/core";
import {selectIsImpersonating} from "store/auth/selectors";
import FfairModal from "view/components/modal/FfairModal";
import TwoFactorMethods, {ViewState} from "view/components/TwoFactorMethods";
import useStyles from "./styles";

type Props = {
  open: boolean;
  onClose: () => void;
  initialView?: ViewState;
};

const TwoFactorSettingsModal: React.FC<Props> = ({
  open,
  onClose,
  initialView,
}) => {
  const classes = useStyles();
  const isImpersonating = useSelector(selectIsImpersonating);

  // Backstop for the whole feature. Every known entry point (SettingsButton,
  // TwoFactorSettingsCard, the Layout deep-link) already hides itself while
  // viewing as another user; guarding the modal too means a new entry point
  // added later cannot expose 2FA management by accident. `TwoFactorMethods`
  // fetches on mount, so returning before render also avoids a burst of 403s.
  if (isImpersonating) {
    return null;
  }

  return (
    <FfairModal open={open} onClose={onClose}>
      <FfairModal.Paper className={classes.paper}>
        <FfairModal.Header className={classes.header}>
          <FfairModal.Title>
            <T keyName="common.two_factor.settings_title" />
          </FfairModal.Title>
        </FfairModal.Header>
        <FfairModal.Body className={classes.body}>
          <TwoFactorMethods initialView={initialView} />
        </FfairModal.Body>
        <FfairModal.Footer className={classes.footer}>
          <Button color="primary" onClick={onClose}>
            <T keyName="common.action.close" />
          </Button>
        </FfairModal.Footer>
      </FfairModal.Paper>
    </FfairModal>
  );
};

export default TwoFactorSettingsModal;
